module.exports = __webpack_public_path__ + "static/media/rightsideimg.51189a1c.webp";